<template>
  <div ref="aap">
    <p>
      <small
        ><center>{{ title }}</center></small
      >
    </p>
    <vue-gauge
      :refid="'_' + Math.random().toString(36).substr(2, 9)"
      :options="myOptions"
      :key="value"
    />
    <!--button @click="value++">Add</button-->
  </div>
</template>

<script>
import VueGauge from "vue-gauge";
export default {
  components: { VueGauge },
  props: {
    title: String,
    value: String,    
  },
  data() {
    return {
      myOptions: {
        chartWidth: window.innerWidth / 4,
        needleValue: ((+this.value) + 30000000) / 600000,
        needleColor: "rgb(93,173,226)",
        arcDelimiters: [ 16, 33, 50, 66, 84 ],
        arcColors: ["rgb(169,50,38)", "rgb(192,57,43)", "rgb(205,97,85)", "rgb(93,173,226)", "rgb(52,152,219)", "rgb(46,134,193)"],
        arcLabels: ["-20.000.000", "-10.000.000", "0", "10.000.000", "20.000.000"],
        arcLabelFontColor: "#fff",
        arcLabelFontSize: 12,
        rangeLabel: ["-30.000.000", "30.000.000"],
        rangeLabelFontColor: "#fff", 
        centralLabel: this.$utils.numberFormat(this.value, 0, ",", "."),
        centralLabelColor: "#fff",
        rangeLabelFontSize: 14,
      },
    };
  },
  mounted() {
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Target all text elements in the gauge */
.vue-gauge >>> text {
  fill: white !important;
  color: white !important;
}

/* Specific elements for better compatibility */
.vue-gauge-label,
.vue-gauge-value,
.vue-gauge-tick-label,
.vue-gauge-arc-label,
.vue-gauge-range-label {
  fill: white !important;
  color: white !important;
}
</style>
